// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__FzhT9","popup--mobile":"styles_popup--mobile__AYUqc","popup--desktop":"styles_popup--desktop__M+hw9"};